module.exports = __webpack_public_path__ + "a2314fc9/img/defaultProductImg.220a180f.svg";